import axios from "axios";
import { store } from "../../store/store";
import { setJackRabbitPrograms } from "store/actions/jackRabbitActions";

/**
 * Fetches program data from the Jackrabbit API and dispatches to Redux store
 *
 * This function makes a POST request to the Ace Gymnastics API endpoint to retrieve
 * program information from the Jackrabbit class management system. The API returns
 * program data including class schedules, availability, and registration information.
 * The fetched data is automatically dispatched to the Redux store for use throughout
 * the application.
 *
 * @param {Object} filters - Optional filters to apply to the program search
 * @param {string} [filters.ProgramId] - Filter by specific program ID
 * @param {string} [filters.LocationId] - Filter by specific location ID
 * @param {string} [filters.ClassId] - Filter by specific class ID
 * @param {string} [filters.StartDate] - Filter by start date
 * @param {string} [filters.EndDate] - Filter by end date
 * @param {boolean} [filters.ShowClosed=true] - Whether to include closed classes (defaults to true)
 *
 * @returns {Promise<Object>} A promise that resolves with the API response data
 * @returns {Array} returns.data.rows - Array of program/class data from Jackrabbit
 *
 * @throws {Error} Logs error to console if the API request fails
 *
 * @example
 * ```javascript
 * // Fetch all programs
 * await fetchPrograms();
 *
 * // Fetch programs with filters
 * await fetchPrograms({
 *   ProgramId: "123",
 *   LocationId: "456",
 *   StartDate: "2024-01-01"
 * });
 * ```
 *
 * @example
 * ```javascript
 * // The function automatically dispatches to Redux store
 * fetchPrograms().then(() => {
 *   // Programs are now available in the Redux store
 *   const programs = store.getState().jackRabbit.programs;
 * });
 * ```
 */
export const fetchPrograms = (filters) => {
  return axios({
    method: "POST",
    url: "https://ace-gymnastics-api.herokuapp.com/programs",
    // url: "http://localhost:9000/programs",
    // url: "https://app.jackrabbitclass.com/jr3.0/Openings/OpeningsJson",
    data: {
      OrgId: process.env.REACT_APP_ORGID,
      ShowClosed: true,
      ...filters,
    },
  })
    .then((result) => {
      store.dispatch(setJackRabbitPrograms(result.data.rows));
    })
    .catch((error) => {
      console.log("catch", error);
    });
};
